/**
 * DOM 就绪检测模块
 * 提供跨浏览器的 document.ready 实现，包含超时保护和错误处理
 * 
 * @module ready
 * @author wei<innereyecw@gmail.com>
 * @version 5.0.0
 */
(function (global) {
  "use strict";

  // 防止重复初始化
  if (global.document.ready !== undefined) {
    return;
  }

  /**
   * DOM 就绪回调函数
   * 在 DOM 完全加载后执行指定的回调函数
   * 
   * @param {Function} callback - DOM 就绪后执行的回调函数
   * 
   * @example
   * document.ready(function() {
   *   console.log('DOM is ready!');
   *   // 在这里操作 DOM
   * });
   * 
   * @features
   * - 支持现代浏览器 (DOMContentLoaded)
   * - 支持 IE8 及以下 (onreadystatechange)
   * - 兜底方案（立即检查）
   * - 超时保护（5秒后强制执行）
   * - 防止重复执行
   * - 错误捕获
   */
  global.document.ready = document.ready = function (callback) {
    let executed = false;
    
    /**
     * 安全执行回调函数
     * 确保只执行一次，并捕获可能的错误
     */
    function safeCallback() {
      if (!executed) {
        executed = true;
        try {
          callback();
        } catch (error) {
          console.error('[ready.js] document.ready callback error:', error);
        }
      }
    }
    
    // ==================== 方法 1: 标准 DOMContentLoaded ====================
    // 适用于现代浏览器 (Chrome, Firefox, Safari, Edge, IE9+)
    if (document.addEventListener) {
      document.addEventListener('DOMContentLoaded', function handler() {
        document.removeEventListener('DOMContentLoaded', handler, false);
        safeCallback();
      }, false);
    } 
    // ==================== 方法 2: IE8 及以下 ====================
    // 使用 onreadystatechange 事件
    else if (document.attachEvent) {
      document.attachEvent('onreadystatechange', function handler() {
        if (document.readyState === "complete") {
          document.detachEvent("onreadystatechange", handler);
          safeCallback();
        }
      });
    }
    // ==================== 方法 3: 兜底方案 ====================
    // 如果 DOM 已经加载完成，立即执行
    else if (document.lastChild === document.body) {
      safeCallback();
    }
    
    // ==================== 方法 4: 超时保护 ====================
    // 5秒后如果仍未执行，强制执行回调
    setTimeout(function() {
      if (!executed) {
        console.warn('[ready.js] document.ready timeout after 5s, forcing execution');
        safeCallback();
      }
    }, 5000);
  };

})(typeof window !== "undefined" ? window : this);
